import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import SlideShow from "../components/slideshow"

const IndexPage = () => {
  return (
    <Layout>
      <SEO title="Home" />
      <SlideShow />
    </Layout>
  )
}

export default IndexPage
